import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";
import Cookies from "js-cookie";

const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
  isAuthenticated: false,
};

// Async thunk for email/password login
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/LoggedInEmailPassword`, loginData);
      console.log(response)
      if (response.data?.status === false) {
        return rejectWithValue({
          message:
            response.data?.message ||
            response.data?.msg ||
            "Invalid email or password",
        });
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: error.message || "Something went wrong",
        }
      );
    }
  }
);

// Async thunk for Google login
export const googleLogin = createAsyncThunk(
  "auth/googleLogin",
  async (accessToken, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/GoogleLogin`, { accessToken });
      if (response.data?.status === false) {
        return rejectWithValue({
          message:
            response.data?.message ||
            response.data?.msg ||
            "Google login failed",
        });
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: error.message || "Something went wrong",
        }
      );
    }
  }
);


const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      Cookies.remove("token");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action?.payload?.data;
        state.token = "token";
        state.isAuthenticated = true;
        Cookies.set("token", "static-token-123", { expires: 7, secure: true, sameSite: "Strict" });
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
      .addCase(googleLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(googleLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action?.payload?.user;
        state.token = "token";
        state.isAuthenticated = true;
        Cookies.set("token", "static-token-123", { expires: 7, secure: true, sameSite: "Strict" });
      })
      .addCase(googleLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
